import script from "./ClockWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClockWidget.vue?vue&type=script&setup=true&lang=ts"

import "./ClockWidget.vue?vue&type=style&index=0&id=4ed01bb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed01bb5"]])

export default __exports__